var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rating)?_c('span',{staticClass:"feedback",class:_vm.ratingClass,attrs:{"title":"Average rating"}},[_vm._v(_vm._s(_vm._f("ratify")(_vm.rating)))]):(_vm.showUnknown)?_c('span',[_vm._v("-")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }